module.exports = __webpack_public_path__ + "img/book.fcc09553.png";